var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("门诊预约问诊管理")]),
            _c("el-breadcrumb-item", [_vm._v("专家问诊管理")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("div", [_vm._v("医生查询：")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "400px" },
              attrs: {
                filterable: "",
                remote: "",
                "remote-method": _vm.remoteMethod,
                placeholder: "请搜索并选择医生",
              },
              on: { change: _vm.onDoctorChange },
              model: {
                value: _vm.doctorId,
                callback: function ($$v) {
                  _vm.doctorId = $$v
                },
                expression: "doctorId",
              },
            },
            _vm._l(_vm.doctorList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item.id, label: item.name },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "im-container box-shadow" }, [
        _c(
          "div",
          { staticClass: "side-bar" },
          _vm._l(_vm.patientList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "patient",
                class: _vm.patientName === item.account ? "patient-active" : "",
                on: {
                  click: function ($event) {
                    return _vm.loadChatMessage(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.account)),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "im-box" }, [
          _c(
            "div",
            {
              ref: "container",
              staticClass: "message-container",
              on: { scroll: _vm.scrollEvent },
            },
            _vm._l(_vm.messageList, function (item) {
              return _c("div", { key: item.id, staticClass: "container" }, [
                item.senderType === 1
                  ? _c("div", { staticClass: "message-box" }, [
                      _c("div", { staticClass: "portrait" }, [
                        _c("span", [_vm._v(_vm._s(_vm.patientName))]),
                      ]),
                      _c("div", { staticClass: "message-content mgl10" }, [
                        item.messageType === 1
                          ? _c("div", { staticClass: "content" }, [
                              _vm._v(" " + _vm._s(item.commentText) + " "),
                            ])
                          : _vm._e(),
                        item.messageType === 2
                          ? _c(
                              "div",
                              [
                                _c("el-image", {
                                  staticClass: "picture",
                                  attrs: {
                                    src: item.picUrl,
                                    "preview-src-list": [item.picUrl],
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "create-time" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatDate")(item.createdTime, true)
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "message-box reverse" }, [
                      _c(
                        "div",
                        { staticClass: "message-content flex-right mgr10" },
                        [
                          item.messageType === 1
                            ? _c("div", { staticClass: "content flex-end" }, [
                                _vm._v(" " + _vm._s(item.commentText) + " "),
                              ])
                            : _vm._e(),
                          item.messageType === 2
                            ? _c(
                                "div",
                                [
                                  _c("el-image", {
                                    staticClass: "picture",
                                    attrs: {
                                      src: item.picUrl,
                                      "preview-src-list": [item.picUrl],
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "create-time flex-end" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatDate")(item.createdTime, true)
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _vm._m(0, true),
                    ]),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "message-sender" }, [
            _c(
              "div",
              { staticClass: "tool-bar" },
              [
                _c(
                  "el-upload",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.patientName,
                        expression: "patientName",
                      },
                    ],
                    staticClass: "upload",
                    attrs: {
                      "before-upload": _vm.handleBeforeUpload,
                      "show-file-list": false,
                      limit: 1,
                      action: "https://fwj-app.servicesplus.cn/upload/",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("上传图片")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "sender" },
              [
                _c("el-input", {
                  staticClass: "input",
                  attrs: {
                    disabled: !_vm.patientName,
                    type: "textarea",
                    rows: 4,
                    resize: "none",
                    placeholder: "请输入您要咨询的问题",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.sendMessage(_vm.message, 1)
                    },
                  },
                  model: {
                    value: _vm.message,
                    callback: function ($$v) {
                      _vm.message = $$v
                    },
                    expression: "message",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "portrait" }, [_c("span", [_vm._v("我")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }